<template>
  <div class="scheduler-modal__buttons">
    <back-cancel-button :active-step="activeStep" v-on="$listeners" />
    <next-save-button
      :active-step="activeStep"
      :disabled-next-button="disabledNextButton"
      :disabled-save-buttons="disabledSaveButtons"
      :disabled-edit-button="disabledEditButton"
      :editedFeed="editedFeed"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BackCancelButton from '@/components/schedulerModal/schedulerButtons/BackCancelButton.vue'
import NextSaveButton from '@/components/schedulerModal/schedulerButtons/NextSaveButton.vue'

export default {
  name: 'SchedulerModalButtons',
  components: {
    BackCancelButton,
    NextSaveButton,
  },
  props: {
    activeStep: {
      type: Number,
      default: 0,
    },
    disabledNextButton: Boolean,
    disabledSaveButtons: Boolean,
    disabledEditButton: Boolean,
  },
  computed: {
    ...mapState({
      editedFeed: (state) => state.cache.cache.editedFeed,
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.scheduler-modal {
  &__buttons {
    display: flex;
    justify-content: space-between;
    &::v-deep [class^='scheduler-modal__save-buttons'] {
      display: flex;
      button:first-child {
        border-radius: $mds-space-3-x 0 0 $mds-space-3-x;
      }
      button:last-child {
        margin-left: 1px;
        padding: 0 $mds-space-1-x 0 $mds-space-1-x;
        border-radius: 0 $mds-space-3-x $mds-space-3-x 0;
      }
    }
  }
}
</style>
